import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import vuescroll from "vue-scroll";
import axios from 'axios';
import VueWechatTitle from 'vue-wechat-title'  //引入
Vue.use(VueWechatTitle)   //注册组件

Vue.prototype.axios = axios

Vue.use(vuescroll, { debounce: 600 });
Vue.use(less)
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
